import React from "react";
import { 
  FooterContainer, 
  FooterContent,
  FooterLeftSection,
  FooterRightSection,
  FooterLogo,
  FooterInfo,
  FooterAddress,
  FooterContact,
  ContactLabel,
  ContactValue,
  EmailLabel,
  SocialMediaContainer,
  MobileSocialContainer,
  PCCopyright,
  MobileCopyright,
  ContactLabelContainer
} from "./styles";
import { useFooter } from "../../contexts/FooterContext";

const Footer = () => {
  const { showFooter } = useFooter();
  
  if (!showFooter) {
    return null;
  }
  
  const handleSocialMedia = (platform: string) => {
    let url = '';
    switch (platform) {
      case 'youtube':
        url = 'https://www.youtube.com/@puzlofficial/';
        break;
      case 'blog':
        url = 'https://blog.naver.com/puzlcorp/';
        break;
      case 'instagram':
        url = 'https://www.instagram.com/pu_zl_duck?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D';
        break;
      default:
        url = 'https://www.puzl.co.kr/';
    }
    window.open(url, '_blank');
  };
  
  return (
    <FooterContainer>
      <FooterLeftSection>
        <FooterContent>
          <FooterLogo>
            PUZL CORP.
            <MobileSocialContainer>
              <div onClick={() => handleSocialMedia('youtube')}>
                <img src="/images/common/header/sns/youtube.svg" alt="YouTube" />
              </div>
              <div onClick={() => handleSocialMedia('blog')}>
                <img src="/images/common/header/sns/naver-blog.svg" alt="Naver Blog" />
              </div>
              <div onClick={() => handleSocialMedia('instagram')}>
                <img src="/images/common/header/sns/instagram.svg" alt="Instagram" />
              </div>
            </MobileSocialContainer>
          </FooterLogo>
          <FooterInfo>
            <FooterAddress>
              서울특별시 마포구 양화로 81, 지하1층 L104호(서교동, H스퀘어)<br />
              주식회사 퍼즐코퍼레이션
            </FooterAddress>
            <FooterContact>
              <ContactLabelContainer>
                <ContactLabel>Tel</ContactLabel>
                <EmailLabel>E</EmailLabel>
              </ContactLabelContainer>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <ContactValue>02-2039-1596</ContactValue>
                <ContactValue>contact@puzl.co.kr</ContactValue>
              </div>
            </FooterContact>
          </FooterInfo>
          <MobileCopyright>© PUZL CORP. all rights served.</MobileCopyright>
        </FooterContent>
      </FooterLeftSection>
      
      <FooterRightSection>
        <SocialMediaContainer>
          <div onClick={() => handleSocialMedia('youtube')}>
            <img src="/images/common/header/sns/youtube.svg" alt="YouTube" />
          </div>
          <div onClick={() => handleSocialMedia('blog')}>
            <img src="/images/common/header/sns/naver-blog.svg" alt="Naver Blog" />
          </div>
          <div onClick={() => handleSocialMedia('instagram')}>
            <img src="/images/common/header/sns/instagram.svg" alt="Instagram" />
          </div>
        </SocialMediaContainer>
        
        <PCCopyright>© PUZL CORP. all rights served.</PCCopyright>
      </FooterRightSection>
    </FooterContainer>
  );
};

export default Footer;
